<template>
	<footer class="footer">
		<div class="container">
			<div class="columns has-text-centered">
				<div class="column">
					<h3 class="title is-footer-size-5">{{ $t('Phone') }}</h3>
					<a href="tel:+36309324435">+36 30 932 4435</a> (10-16h)
				</div>
				<div class="column">
					<h3 class="title is-footer-size-5">{{ $t('Email') }}</h3>
					<a href="mailto:info@htaukcio.com">info@htaukcio.com</a>
				</div>
				<div class="column">
					<h3 class="title is-footer-size-5">{{ $t('Address') }}</h3>
					<a href="https://goo.gl/maps/SJj1VnE1gBwhdQsJ9" target="_blank" rel="noopener noreferrer">1066 Budapest, Zichy Jenő u. 1.</a
					>
				</div>
			</div>
		</div>
		<hr>
		<div class="container">
			<div class="footer-bottom-menu">
				<div v-for="item in footerBottomMenu" :key="item.id">
					<p v-html="item.body"></p>
				</div>
			</div>
			<div class="columns is-vcentered has-text-centered">
				<div class="column is-paddingless">
					<img class="footer-logo" src="@/assets/images/logo.png" height="40" alt="HT Auction logo" />
				</div>
				<div class="column is-paddingless">
					<div class="content">
						<img src="@/assets/images/EU-European-Union-Flag-icon.png" :alt="$t('EU flag')">
						<p><strong>HT Auction Kft.</strong> - Minden jog fenntartva.</p>
					</div>
				</div>
				<div class="column is-paddingless">
					<a href="https://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf" target="_blank">
						<img src="@/assets/images/simplepay_w140.png" alt="Simple logo" />
					</a>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	data() {
		return {
			footerMenu: [],
			shipping: [],
			footerBottomMenu: [],
		}
	},
	mounted() {
		var _this = this
		this.$root.$on('change_locale', function () {
			_this.translation()
		})
		_this.translation()
	},
	methods: {
		translation() {
			if (this.$i18n) {
				if (this.$i18n.locale == 'en') {
					this.$http.get('/cms/en-footer-bottom-menu').then((response) => {
						this.footerBottomMenu = response.data.cms
					})
				}
				if (this.$i18n.locale == 'hu') {
					this.$http.get('/cms/hu-footer-bottom-menu').then((response) => {
						this.footerBottomMenu = response.data.cms
					})
				}
			}
		},
	},
}
</script>

<style lang="scss">
.footer {
	padding: 1rem;
	border-top: 2px solid #1a454a;
	p, a {
		font-size: 0.9rem
	}

	p:not(:last-child) {
		margin-bottom: 1rem;
	}

	label {
		font-weight: bold;
	}

	h3 {
		font-size: 1.5rem;
	}

	.footer-bottom-menu {
		text-align: center;
		li {
			display: inline-block;
			margin: 1rem;
			a {
				padding: 1rem;
			}
		}
	}

	.title {
		margin-bottom: 0.5rem;
	}

	.footer-logo {
		max-width: 12rem;
	}

	hr {
		margin: 0.75rem 0;
	}

	.is-footer-size-5 {
		font-size: 1.15rem;
	}
}
</style>
